import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePageSeo } from '../i18n/usePageSeo';
import PageMeta from './PageMeta';

/** Applies per-route title, meta tags, canonical URL, Open Graph, and JSON-LD. */
const RouteMeta: React.FC = () => {
  const { pathname } = useLocation();
  const seo = usePageSeo(pathname);

  return <PageMeta seo={seo} />;
};

export default RouteMeta;
